import holidays2022 from './2022';
import holidays2023 from './2023';
import holidays2024 from './2024';
import holidays2025 from './2025';
import holidays2026 from './2026';
import _ from 'lodash';

const calendar = {
  2022: holidays2022,
  2023: holidays2023,
  2024: holidays2024,
  2025: holidays2025,
  2026: holidays2026
};

export default {
  for(year) {
    if (this.has(year)) {
      return calendar[year];
    } else {
      return [];
    }
  },

  has(year) {
    return year in calendar;
  },

  years() {
    return _.keys(calendar);
  }
};
